
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  MeterValueAdjustmentPostResponseBody,
  MeterValueAdjustmentRequest,
} from '../entities/meter-value-adjustment-config/models';
import { axiosInstance } from "../axios-instance";

class MeterValueAdjustmentConfig {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  meterValueAdjustmentByDevice(
    input: MeterValueAdjustmentRequest,
  ): Promise<AxiosResponse<MeterValueAdjustmentPostResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<MeterValueAdjustmentPostResponseBody>(`${this.baseUrl}/queueConfigs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default MeterValueAdjustmentConfig;
